export default __webpack_public_path__ + "static/media/Gilroy-ThinItalic.934c6cd5.woff";